import React from 'react';

type Props = {
  isLastSubrow: boolean;
};

export const AccountSubrowCell: React.FC<Props> = ({
  isLastSubrow,
}): JSX.Element => {
  const verticalLineClassName = `${
    isLastSubrow ? 'last' : ''
  } account-subrow-vertical-line`;

  const attrs = {
    wrapper: {
      className: 'account-subrow',
    },

    verticalLine: {
      className: verticalLineClassName,
    },

    horisontalLine: {
      className: 'account-subrow-horisontal-line',
    },
  };

  return (
    <div {...attrs.wrapper}>
      <div {...attrs.verticalLine} />
      <div {...attrs.horisontalLine} />
    </div>
  );
};
